import { render, staticRenderFns } from "./article-queries.vue?vue&type=template&id=31717fcd&scoped=true"
import script from "./article-queries.vue?vue&type=script&lang=js"
export * from "./article-queries.vue?vue&type=script&lang=js"
import style0 from "./article-queries.vue?vue&type=style&index=0&id=31717fcd&prod&lang=scss&scoped=true"
import style1 from "./article-queries.vue?vue&type=style&index=1&id=31717fcd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31717fcd",
  null
  
)

export default component.exports